<template>
  <div id="app">
    <div v-if="dictionary">
      <div class="cs3-trial-box">
      <span class="cs3-trial-title" v-html="dictionary.requestItNow"> </span>   
    <div v-if="steps.form">
      <div class="cs3-trial-text"> {{dictionary.compraSocialOffers}} <strong>{{dictionary.each30Days20FollowersFree}}</strong></div>
      <InputText :inputType="'email'" :inputID="'email'" v-model="trial_email" :placeHolder="dictionary.emailPlaceholder"></InputText>
      <div class="cs3-trial-attention">
        <strong class="cs3-trial-attention--strong">{{dictionary.attention}}:</strong>
        {{dictionary.rememberToSetTheProfilePublic}}
      </div>
      <InputText :inputType="'text'" :inputID="'username'" v-model="trial_username" :placeHolder="dictionary.usernamePlaceholder"></InputText>
      <div id="acceptMarketingPurposesContainer">
        <label for="checkboxMarketingPurposes" id="checkboxMarketingPurposesLabel">
          <input type="checkbox" name="acceptMarketingGoal" id="checkboxMarketingPurposes" v-model="acceptMarketingPurposes">
          {{dictionary.acceptMarketingPurposes}}
        </label>
      </div>
      <CsButton 
      additionalClasses="cs-button__green"
      :text="dictionary.request20Followers"
      @buttonClicked="initTrialRequest"
      ></CsButton>
      
    </div>
    <CsLoader :isShown="steps.isLoading"></CsLoader>
    <EmailVerification 
      :isShown="steps.emailVerification"
      :dictionaryFile="dictionary"
      :userInfo="userInfo"
      :username="trial_username"
      :email="trial_email"
      @beginVerification="onBeginEmailVerification()"
      @correctEmailCode="onEmailVerificationSuccess()"
      @failedEmailVerification="onEmailVerificationFail()"
      ></EmailVerification>

      <WaitingTimer 
      :dictionaryFile="dictionary"
      :isShown="steps.waiting"
      @waitIsFinishing="onWaitingFinishing()"
      @waitFinished="onWaitingFinished()"
      ></WaitingTimer>

    <div v-if="steps.final">
      <div v-if="isError">
        <div class="cs3-trial-finalIconContainer">
          <img :src="dictionary.errorIcon" class="cs3-trial-finalIcon" alt="error icon comprasocial.me">
        </div>
        <div v-if="errors.isAlreadyRequested" v-html="dictionary.errors.alreadyRequested" class="cs3-trial__finalTextMain"></div>
        <div v-if="errors.isAlreadyRequested" class="cs3-trial__finalTextLight">{{dictionary.doYouWantToGetMoreFollowers}}</div>
        <CsButton 
        v-if="errors.isAlreadyRequested && !flags.specialOffersShown"
        additionalClasses="cs-button__purple"
        :text="dictionary.iWantMoreLikes"
        @buttonClicked="goToServicePage"/>
        <!-- Is Invalid Email Section -->
        <span v-if="errors.isInvalidEmail" class="cs3-trial__finalTextMain" v-html="dictionary.errors.invalidEmail"></span>
        <CsButton 
        v-if="errors.isInvalidEmail"
        additionalClasses="cs-button__orange"
        :text="dictionary.changeEmailAndTryAgain"
        @buttonClicked="restartForm"/>

         <!-- Is profile private -->
        <span v-if="userInfo.isPrivate" class="cs3-trial__finalTextMain" v-html="dictionary.errors.privateProfile"></span>
        <CsButton 
        v-if="userInfo.isPrivate"
        additionalClasses="cs-button__orange"
        :text="dictionary.changeUsernameAndTryAgain"
        @buttonClicked="restartForm"/>

        <!-- Is profile not found -->
        <span v-if="errors.profileNotFound" class="cs3-trial__finalTextMain" v-html="dictionary.errors.profileNotFound"></span>
        <CsButton 
        v-if="errors.profileNotFound"
        additionalClasses="cs-button__orange"
        :text="dictionary.changeUsernameAndTryAgain"
        @buttonClicked="restartForm"/>

        <!-- Profile do not have medias -->
        <span v-if="!userInfo.isPrivate && errors.noMediaFound" class="cs3-trial__finalTextMain" v-html="dictionary.errors.noMediaFound"></span>
        <CsButton 
        v-if="!userInfo.isPrivate && errors.noMediaFound"
        additionalClasses="cs-button__orange"
        :text="dictionary.changeUsernameAndTryAgain"
        @buttonClicked="restartForm"/>
      </div>
      <div v-if="isSuccess">
        <div class="cs3-trial-finalIconContainer">
          <img :src="dictionary.successIcon"  class="cs3-trial-finalIcon" alt="success icon comprasocial.me">
        </div>
        <span class="cs3-trial__finalTextMain" v-html="dictionary.serviceSent"></span> <br>
        <span class="cs3-trial__finalTextLight" v-html="dictionary.inTheNextHoursYouWillReceiveThem"></span>
      </div>
        <CrossSell 
        :isShown="!errors.isInvalidEmail && !errors.noMediaFound && !errors.profileNotFound && !userInfo.isPrivate"
        :dictionaryFile="dictionary"
        :userInfo="userInfo"
        @showSpecialOffers="onShowSpecialOffers" />
      </div>
      </div>
      <ServiceDetail 
      :isShown="!errors.isInvalidEmail && !errors.noMediaFound && !errors.profileNotFound && !userInfo.isPrivate && steps.final && flags.specialOffersShown"
      :dictionaryFile="dictionary"/>
  </div>
  </div>
</template>

<script>
import axios from "axios";
import InputText from "./components/form/inputText/inputText.vue";
import CrossSell from "./components/crossSell/crossSell.vue";
import CsLoader from "./components/loader/loader.vue"
import EmailVerification from './components/emailVerification/emailVerification.vue';
import ServiceDetail from './components/serviceDetail/serviceDetail.vue';
import CsButton from './components/form/button/button.vue';
import WaitingTimer from './components/waitingTimer/waitingTimer.vue';
import {API_URL,ADD_EMAIL_VERIFICATION_ENDPOINT, EXEC_TRIAL_ENDPOINT, TK_USER_ENDPOINT, TK_USER_FEED_ENDPOINT, DEFAULT_HEADER, getTkUserRequestBody, getTrialRequestBody} from "./assets/js/api";
import {shakeElementByID} from "./assets/js/csService";
const siteURL = window.location.origin;
export default {
  name: "App",
  data: function() {
    return {
      trial_email: "",
      trial_username: "",
      userInfo: {},
      selectedMedia: "",
      steps: {
        form: true,
        emailVerification: false,
        waiting: false,
        final: false,
        isLoading: false
      },
      flags: {
        specialOffersShown: false,
      },
      specialOffers: {},
      errors: {
        isAlreadyRequested: false,
        isInvalidEmail: false,
        profileNotFound: false,
        noMediaFound: false
      }, 
      isError: false,
      isSuccess: false,
      dictionary: null,
      acceptMarketingPurposes: false,
    };
  },
  components: {
    InputText, 
    CrossSell,
    EmailVerification,
    CsLoader,
    CsButton,
    ServiceDetail,
    WaitingTimer
  },
  methods: {
    initTrialRequest: async function() {
      this.checkIfValidForm();
      if (this.checkIfValidForm()) {
        this.steps.form = false;
        this.steps.isLoading = true;
        await this.setUserID();
        if(this.isError){
          this.steps.final = true;
          this.steps.isLoading = false;
          return;
        }
        // eslint-disable-next-line no-undef
        await axios.post( `${API_URL}${ADD_EMAIL_VERIFICATION_ENDPOINT}`, getTrialRequestBody(this.userInfo.uid, this.trial_email, this.trial_username, currentLanguage), DEFAULT_HEADER )
          .then(res => {
            this.steps.isLoading = false;
            if(res.data.status == 1){
              this.steps.emailVerification = true;
              setTimeout(() => {this.setSlidingPhotos()}, 500);
            } else if( res.data.status == -1){
              this.steps.final = true;  
              this.isError = true;
              this.errors.isAlreadyRequested = true;
            } else if (res.data.status == -3){
              this.steps.final = true;  
              this.isError = true;
              this.errors.isInvalidEmail = true;
            }
          })
          .catch(() => {
            this.steps.isLoading = false;
            this.isError = true;
          });
      }
    },
    onBeginEmailVerification(){
      this.isEmailCodeWrong = false;
      this.steps.emailVerification = false;
      this.toggleLoader();
    },
    onEmailVerificationFail(){
      this.isEmailCodeWrong = false;
      this.toggleLoader();
      this.steps.emailVerification = true;
    },
    onEmailVerificationSuccess(){
      this.toggleLoader();
      this.steps.waiting = true;
    },
    toggleLoader(){
      this.steps.isLoading = !this.steps.isLoading;
    },
    onWaitingFinishing(){
      this.sendTrial();
    },
    onWaitingFinished(){
      this.steps.waiting = false;
      this.steps.final = true;  
      this.isSuccess = true;
    },
    onShowSpecialOffers(givenValue){
      this.flags.specialOffersShown = givenValue;
    },
    setUserID(){
      return axios.all([
        axios.post(`${API_URL}${TK_USER_ENDPOINT}`, getTkUserRequestBody(this.trial_username), DEFAULT_HEADER ),
        axios.post(`${API_URL}${TK_USER_FEED_ENDPOINT}`, getTkUserRequestBody(this.trial_username), DEFAULT_HEADER )
      ]).then((res)=> {
        this.userInfo = res[0].data;
        if(this.userInfo.isPrivate){
          this.isError = true;
        } else if( res[1].data.videos.length > 0 ) {
            this.userInfo.medias = res[1].data.videos;
            this.userInfo.selectedMedia = res[1].data.videos[0];
        } else {
          this.errors.noMediaFound = true;
          this.isError = true;
        }
      }).catch(() => {
        this.userInfo = {};
        this.errors.profileNotFound = true;
        this.isError = true;
      });
    },
    sendTrial: async function () {
      // eslint-disable-next-line no-undef
      await axios.post(`${API_URL}${EXEC_TRIAL_ENDPOINT}`,  getTrialRequestBody(this.userInfo.uid, this.trial_email, this.trial_username, currentLanguage, this.userInfo.medias));
    },
    checkIfValidUsername: function() {
      this.cleanUsername();
      return !(this.trial_username == "");
    },
    checkIfValidEmail: function() {
      return !(this.trial_email == "" || !this.trial_email.match("@"));
    },
    checkIfValidForm: function() {
      if(!this.checkIfValidEmail()){
        shakeElementByID("email");
        return false; 
      }
      if(!this.checkIfValidUsername()){
        shakeElementByID("username");
        return false; 
      }
      if(!this.acceptMarketingPurposes) {
        shakeElementByID("acceptMarketingPurposesContainer");
        return false;
      } 
      return true;
    },
    cleanUsername: function() {
      this.trial_username = this.trial_username.replace(" ",'');
      this.trial_username = this.trial_username.replace(new RegExp('.*tiktok.com/'),'');
      this.trial_username = this.trial_username.replace(new RegExp('^@'),'');
      this.trial_username = this.trial_username.replace(new RegExp('/video/.*'),'');
    },
    restartForm(){
      this.steps.isLoading = false;
      this.isError = false;
      this.steps.final = false;
      this.errors.profileNotFound = false;
      this.errors.isInvalidEmail = false;
      this.errors.noMediaFound = false;
      this.steps.form = true;
      this.trial_email = "";
      this.trial_username = "";
    },
    goToServicePage(){
      location.href = this.dictionary.servicePage;
    },
    setSlidingPhotos() {
        const slider = document.querySelector('.cs4-profilePhotos');
        let isDown = false;
        let startX;
        let scrollLeft;
        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 1.5; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
    },
  },
  mounted: function() {
      // eslint-disable-next-line no-undef
      axios.get( siteURL + '/wp-content/themes/cs-theme/assets/sliders-dictionaries/trial/tk/views/dictionary-' + currentLanguage + '.json').then(
      (res) => {
        this.dictionary = res.data;
      }
    );
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;600;700&display=swap');
@import './assets/css/finalStep.css';
@import './assets/css/inputError.css';

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #6c6d7e;
  padding: 10px;
}

.cs3-trial-title {
  font-size: 16px;
  color: #AA61D8;
  font-weight: 700;
  margin-bottom: 5px;
  display: block;
  padding-top:15px;
}

.cs3-trial-text {
  font-size: 13px;
  padding: 0 20px;
  margin: 15px 0;
}

.cs3-trial-box {
  max-width: 400px;
  background: white;
  margin: 0 auto 10px;
  border-radius: 25px;
  overflow: hidden;
}

.cs3-trial-attention {
  font-size: 13px;
  padding: 0 30px;
}

.cs3-trial-attention--strong {
  color: #f15b65;
  display: block;
}

.cs3-trial-link {
  text-decoration: none;
  color: #cc3366;
}

.cs3-trial-icon {
  width: 25px;
  height: 25px;
}

#acceptMarketingPurposesContainer {
  font-size: 13px;
  padding: 0 30px 0 15px;
}

</style>
